// extracted by mini-css-extract-plugin
export default {"category":"style_category__nULTW"};